import { useEffect } from "react";
import { useLocation, useMatches } from "react-router-dom";
import ReactGA from "react-ga4";

export const usePageTracking = () => {
  const location = useLocation();
  const matches = useMatches();

  useEffect(() => {
    // Find the deepest route with a title handle
    const title = matches
      .reverse()
      .find((m) => m.handle?.title)?.handle.title;

    // Update document title
    document.title = title ? `${title} | Aardstats.com` : "Aardstats.com";

    // Send page view to GA4
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search + location.hash,
      title: document.title
    });
  }, [location, matches]);
};
